/**
 * DraftsList — list view of saved drafts in the "drafts" folder.
 *
 * Iteration 104 — Batch 3 component split.
 */
import React from 'react';

export default function DraftsList({
  drafts,
  selectedDraftId,
  formatDate,
  onEdit,
  onDelete,
}) {
  if (!drafts || drafts.length === 0) {
    return (
      <div className="p-8 text-center text-slate-500 dark:text-slate-400">
        <svg className="w-12 h-12 mx-auto mb-3 text-slate-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
        <p className="font-medium">No drafts</p>
        <p className="text-sm mt-1">Compose an email and click "Save Draft" to save it here</p>
      </div>
    );
  }
  return (
    <>
      {drafts.map((draft) => (
        <div
          key={draft.id}
          className={`p-3 border-b border-slate-100 dark:border-slate-700 cursor-pointer transition hover:bg-slate-50 dark:hover:bg-slate-700 ${
            selectedDraftId === draft.id ? 'bg-blue-50 dark:bg-blue-900/30' : ''
          }`}
          data-testid={`draft-item-${draft.id}`}
        >
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <span className="text-xs px-1.5 py-0.5 bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 rounded">Draft</span>
                <span className="text-sm text-slate-700 dark:text-slate-300 truncate">
                  {draft.to?.join(', ') || '(no recipients)'}
                </span>
              </div>
              <p className="text-sm text-slate-600 dark:text-slate-400 truncate mt-0.5">
                {draft.subject || '(no subject)'}
              </p>
              <p className="text-xs text-slate-400 truncate mt-0.5">
                {draft.body?.substring(0, 80) || '(no content)'}
              </p>
            </div>
            <div className="flex flex-col items-end gap-1 flex-shrink-0">
              <span className="text-xs text-slate-400">{formatDate(draft.updated_at)}</span>
              <div className="flex items-center gap-1">
                <button
                  onClick={(e) => { e.stopPropagation(); onEdit(draft); }}
                  className="text-blue-600 hover:text-blue-800 p-1"
                  title="Edit draft"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                </button>
                <button
                  onClick={(e) => { e.stopPropagation(); onDelete(draft.id); }}
                  className="text-slate-400 hover:text-red-600 p-1"
                  title="Delete draft"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
